import React, { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Button, Grid, Form, Card, Icon } from "semantic-ui-react";
import { server } from "../../App";
import { columnDefs, topOptions, bottomOptions } from "./GridParams/GridParams";
import { useQuery } from "react-query";
import { useForm } from "react-hook-form";
import moment from "moment";
import { useNavigate, useLocation } from "react-router-dom";
import { useWindowSize } from "react-use";
import {
  emptyState_form_load,
  emptyState_act_form_load,
  InitialRowData1And2,
  getDoctors
} from "../Api/api";
import { useSelector, useDispatch } from "react-redux";
import {
  Globalfk_id_medecinSelect,
  form_load,
  act_form_load,
  selectPatientelleGrid,
  fetch_success_DUO,
  fetch_success,
  GlobalDATEPatientelle
} from "../../features/patientelle/patientelleSlice";
import { selectisAuthenticated } from "../../features/auth/authSlice";
import { toast } from "react-toastify";
import CustomLink from "../customLink/CustomLink";
import SpeedDialComponent from "../SpeedDial/SpeedDialComponent"

function ActPatientGrid(props) {
  // const { date } = props;
  // let date = moment().format("YYYY-MM-DD");
  // let dateLisible = moment().format("DD-MM-YYYY");
  let navigate = useNavigate();
  let location = useLocation();

  const PatientelleState = useSelector(selectPatientelleGrid);
  const authState = useSelector(selectisAuthenticated);
  // APP state
  const dispatch = useDispatch();
  const { register, handleSubmit } = useForm({ mode: "onChange" });

  const [, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [hideColumn, setHideColumn] = useState(false);
  const { width, height } = useWindowSize();
  const [NewHeightValue, setNewHeightValue] = useState("87vh");
  const [pionter, setNewPointer] = useState(true);

  const GetAllDoctors = useQuery("GetAllDoctors", () =>
    getDoctors()
  );

  let Doctors_list = "";

  if (GetAllDoctors?.data) {
    Doctors_list = GetAllDoctors?.data.map((item, index) => (
      <option className="item" key={index} value={item.idAuth}>
        {item.user_name}
      </option>
    ));
  }

  const onSubmit = async (data) => {
    let url, url2;
    if (data?.date_consultation?.length > 9) {
      url = `${server}actesDidntCome/ActesAtDate/${data.date_consultation}/${data.fk_id_medecin1}`;
      url2 = `${server}actesDidntCome/ActesAtDateFooter/${data.date_consultation}/${data.fk_id_medecin1}`;
    }

    axios
      .get(url, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch(fetch_success(response.data));
        dispatch(GlobalDATEPatientelle(data.date_consultation));
        dispatch(Globalfk_id_medecinSelect(data.fk_id_medecin1));
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(url2, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch(fetch_success_DUO(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const GetData = async (data, m) => {
    // console.log("data", data);
    let url, url2;
    if (data?.length > 9) {
      url = `${server}actesDidntCome/ActesAtDate/${data}/${PatientelleState.fk_id_medecinSelect}`;
      url2 = `${server}actesDidntCome/ActesAtDateFooter/${data}/${PatientelleState.fk_id_medecinSelect}`;
    }

    axios
      .get(url, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch(fetch_success(response.data));

        const { civilite, nom, prenom, actionTypeSocket } = m || {};
        if (actionTypeSocket === "a été encaissé") {
          toast.success(`${civilite} ${nom} ${prenom} ${actionTypeSocket}`, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        } else if (actionTypeSocket === "a été ajouté") {
          toast.warn(`${civilite} ${nom} ${prenom} ${actionTypeSocket}`, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        }
      })

      .catch((error) => {
        console.log(error);
      });
    axios
      .get(url2, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch(fetch_success_DUO(response.data));
      })

      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    let date_object_for_startup = { date_consultation: PatientelleState.globalchoseDate, fk_id_medecin1: PatientelleState.fk_id_medecinSelect };
    onSubmit(date_object_for_startup);
    // eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   function receivedMessage(m) {
  //     GetData(date, m);
  //   }
  //   socket.on("delete", receivedMessage);
  //   socket.on("add", receivedMessage);
  //   socket.on("update", receivedMessage);
  //   socket.on("transfer", receivedMessage);
  //   return () => {
  //     socket.off("delete", receivedMessage);
  //     socket.off("add", receivedMessage);
  //     socket.off("update", receivedMessage);
  //     socket.off("transfer", receivedMessage);
  //   };
  //   // eslint-disable-next-line
  // }, []);

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
    // params.api.sizeColumnsToFit();
    // gridApi?.resetRowHeights();
  };

  topOptions.alignedGrids.push(bottomOptions);
  bottomOptions.alignedGrids.push(topOptions);

  const showColumn = () => {
    gridColumnApi.setColumnsVisible(
      ["age", "created_at", "sum_act"],
      hideColumn
    );

    setHideColumn(!hideColumn);
    // to fit the size of column FIX COLUMN BUG
    // gridApi.sizeColumnsToFit();
  };

  const onSelectionChanged = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      dispatch(act_form_load(emptyState_act_form_load));
    } else {
      let clientArray = e.api.getSelectedRows()[0];
      var datePartsStart = clientArray.date_consultation.substring(0, 10);
      var dateParts = datePartsStart.split("/");

      var cellDate = new Date(
        Number(dateParts[2]),
        Number(dateParts[1]) - 1,
        Number(dateParts[0])
      );
      let fix = moment(cellDate).format("YYYY-MM-DD");

      let pair = { date_consultation: fix };
      let obj = { ...clientArray, ...pair };

      for (const property in obj) {
        if (obj[property] === null) {
          pair = { [property]: "" };
          obj = { ...obj, ...pair };
        }
      }

      dispatch(act_form_load(obj));
    }
  };

  const onRowDoubleClicked = (e) => {
    e.defaultPrevented = true;
    if (e.api.getSelectedRows()[0] === undefined) {
      dispatch(form_load(emptyState_form_load));
    } else {
      let clientArray = e.api.getSelectedRows()[0];
      var datePartsStart = clientArray.date_consultation.substring(0, 10);
      var dateParts = datePartsStart.split("/");

      var cellDate = new Date(
        Number(dateParts[2]),
        Number(dateParts[1]) - 1,
        Number(dateParts[0])
      );
      let fix = moment(cellDate).format("YYYY-MM-DD");

      let pair = { date_consultation: fix };
      let obj = { ...clientArray, ...pair };

      for (const property in obj) {
        if (obj[property] === null) {
          pair = { [property]: "" };
          obj = { ...obj, ...pair };
        }
      }
      // let ConsultationObj = { ID: obj.fk_id_patient1 };

      // dispatch(act_form_load(obj));
      // navigate("/Consultation");

      axios
        .get(`${server}users/SearchUserByID/${obj.fk_id_patient1}`, {
          headers: {
            jwtoken: sessionStorage.token,
          },
        })
        .then((response) => {
          // setTimeout(() => dispatch(form_load(response.data[0])), 330);
          dispatch(form_load(response.data[0]));
          // dispatch(act_form_load(obj));
          navigate("/Consultation");
          // toast.success("success");
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  // const onFirstDataRendered = () => {
  //   topGrid.columnApi.autoSizeAllColumns();
  // };

  const handleTransferToWaitingList = async () => {
    const { date_consultation, fk_id_patient1, done, bloc, didnt_come } =
      PatientelleState;
    const data = { date_consultation, fk_id_patient1, done, bloc, didnt_come };

    await axios({
      method: "put",
      responseType: "json",
      url: `${server}actesDidntCome/updateActe`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    }).then((response) => {
      // socket.emit("transfer", data);
      GetData(date_consultation, {})
      toast.warn("transfer à la salle d'attente", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    });
  };

  const handleRemoveItem = async () => {
    const { date_consultation, fk_id_patient1 } = PatientelleState;

    axios({
      method: "DELETE",
      responseType: "json",
      url: `${server}actesDidntCome/deleteActe/${date_consultation}/${fk_id_patient1}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    }).then((response) => {
      // socket.emit("delete", date_consultation);

      GetData(date_consultation, date_consultation);
      toast.warn("Success", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    });
  };

  function name(height, width) {
    if (height <= 702 && height >= 600 && width >= 1260 && width <= 1366) {
      setNewHeightValue("82vh");
    } else {
      setNewHeightValue("80.5vh");
    }
  }
  useEffect(() => {
    name(height, width);
  }, [height, width]);

  let summary = (
    <>
      <span style={{ fontWeight: 900, fontStyle: "italic" }}>
        Total Fact. :{" "}
        <span
          style={{ fontWeight: 900, color: "royalblue", fontStyle: "italic" }}
        >
          {" "}
          {PatientelleState.rowData2[0]?.sum_act
            ? `${PatientelleState.rowData2[0]?.sum_act} DH`
            : "0 DH"}
        </span>
      </span>
      <span
        style={{
          paddingLeft: "0.6rem",
          fontWeight: 900,
          fontStyle: "italic",
        }}
      >
        Encaiss. :{" "}
        <span
          style={{
            fontWeight: 900,
            color: "#04aa6d",
            fontStyle: "italic",
          }}
        >
          {" "}
          {PatientelleState.rowData2[0]?.payment
            ? `${PatientelleState.rowData2[0]?.payment} DH`
            : "0 DH"}
        </span>
      </span>
      <span
        style={{
          paddingLeft: "0.6rem",
          fontWeight: 900,
          fontStyle: "italic",
        }}
      >
        Reste :{" "}
        <span
          style={{
            fontWeight: 900,
            color: "orangered",
            fontStyle: "italic",
          }}
        >
          {" "}
          {PatientelleState.rowData2[0]?.rest
            ? `${PatientelleState.rowData2[0]?.rest} DH`
            : "0 DH"}
        </span>
      </span>
    </>
  );
  if (location.pathname === "/ActPatientGrid") {
    summary = null;
  }

  if (authState.role !== "admin") {
    summary = null;
  }

  const Style = {
    fontWeight: 900,
    fontStyle: "oblique",
    fontSize: "x-large",
    paddingRight: "1rem",
  };
  const Style2 = {
    fontWeight: 900,
    fontStyle: "oblique",
    fontSize: "x-large",
    // paddingRight: "1rem",
  };
  useEffect(() => {
    if (width === 512) {
      setNewPointer(true);
    } else {
      setNewPointer(false);
    }
  }, [width]);

  const InitializeRowData1And2 = () => {
    dispatch(fetch_success(InitialRowData1And2.rowData));
    dispatch(fetch_success_DUO(InitialRowData1And2.rowData2));
  };

  return (
    <div>
      <Grid columns="equal" centered className="fixWidth2">
        <Grid.Row>
          <Form onChange={handleSubmit(onSubmit)} className="fixWidth2">
            <Form.Group widths="equal" className="fixForm">
              <Card fluid className="historicCss" style={{ margin: 0 }}>
                <Card.Content>
                  {/* <Card.Meta className="MetaAGE">Statistiques du Jour :</Card.Meta> */}
                  <Card.Description className="inline_text_fix">
                    <CustomLink
                      className="floatLeft"
                      to="/"
                      onClick={InitializeRowData1And2}
                    >
                      <span style={Style}>Patientèle</span>
                    </CustomLink>
                    <CustomLink className="floatRight" to="/ActPatientGridHistoric">
                      <span style={pionter ? Style2 : Style}>
                        Salle d'Attente
                      </span>
                    </CustomLink>
                    <CustomLink className="floatLeft" to="/ActPatientGridDoneHistoric">
                      <span style={Style}>Accomplie</span>
                    </CustomLink>
                    <CustomLink
                      className="floatRight"
                      to="/ActPatientGridDidntComeHistoric"
                    >
                      <span style={Style}>Absents</span>
                    </CustomLink>
                  </Card.Description>
                  <Card fluid>
                    <Card.Description>{summary}</Card.Description>
                  </Card>
                </Card.Content>
              </Card>
              <Card fluid={width < 720 ? true : false} style={{ margin: 0 }}>
                <Card.Description>
                  <Grid.Row>
                    <Grid.Column>
                      <input
                        // className="dateMediaQuery"
                        style={{
                          width: "auto",
                          marginTop: "0.5rem",
                          marginBottom: "0.5rem",
                          // float: "left"
                        }}
                        defaultValue={PatientelleState.globalchoseDate}
                        type="date"
                        name="date_consultation"
                        min="1900-01-01"
                        max="3018-12-31"
                        {...register("date_consultation")}
                      ></input>

                    </Grid.Column>
                    <Grid.Column>
                      <select
                        defaultValue={PatientelleState.fk_id_medecinSelect}
                        name="fk_id_medecin1"
                        // role="listbox"
                        aria-expanded="false"
                        className="ui selection dropdown SomeMarginQuerry"
                        style={{
                          width: "auto",
                          marginBottom: "0.5rem"
                        }}
                        required
                        {...register("fk_id_medecin1")}
                      // onChange={(e) => dispatch(Globalfk_id_medecinSelect(e.target.value))}
                      >
                        <option className="item" value={0}>
                          Choisissez un médecin
                        </option>
                        {Doctors_list}
                      </select>
                    </Grid.Column>
                  </Grid.Row>
                </Card.Description>

              </Card>
            </Form.Group>
          </Form>
        </Grid.Row>
        <Grid.Row className="pasdepadding">
          <Button.Group vertical={width <= 767 ? true : false}>
            {PatientelleState?.nom === undefined ? (
              <Button icon labelPosition='left' className="IconFixDopdown" color="teal">
                <Icon name='wait' size='large' />
                Liste d'attente
              </Button>
            ) : PatientelleState?.nom === "" ? (
              <Button icon labelPosition='left' className="IconFixDopdown" color="teal">
                <Icon name='wait' size='large' />
                Liste d'attente
              </Button>
            ) : (
              <Button
                icon labelPosition='left'
                className="IconFixDopdown"
                color="teal"
                onClick={handleTransferToWaitingList}
              >
                <Icon name='wait' size='large' />
                Liste d'attente
              </Button>
            )}
            {PatientelleState?.nom === undefined ? (
              <Button icon labelPosition='left' className="IconFixDopdown" color="red">
                <Icon name='delete' size='large' />
                Supprimer de la liste
              </Button>
            ) : PatientelleState?.nom === "" ? (
              <Button icon labelPosition='left' className="IconFixDopdown" color="red">
                <Icon name='delete' size='large' />
                Supprimer de la liste
              </Button>
            ) : (
              <Button
                icon labelPosition='left'
                className="IconFixDopdown"
                color="red"
                onClick={handleRemoveItem}
              >
                <Icon name='delete' size='large' />
                Supprimer de la liste
              </Button>
            )}
            <Button icon labelPosition='left' onClick={showColumn} className="littleMarginBottom">
              <Icon name='expand' size='large' />
              {hideColumn === true
                ? "Affichage Avancé"
                : "Afffichage Basic"}
            </Button>
          </Button.Group>
        </Grid.Row>
      </Grid>
      <div
        id="myGrid"
        className="ag-theme-alpine"
        style={{
          height: NewHeightValue,
          width: "100%",
          flex: "1 1 auto",
        }}
      >
        <AgGridReact
          rowData={PatientelleState.rowData}
          animateRows={true}
          sortingOrder={["desc", "asc", null]}
          onGridReady={onGridReady}
          columnDefs={columnDefs}
          // defaultColDef={defaultColDef}
          rowSelection={"single"}
          onSelectionChanged={onSelectionChanged}
          gridOptions={topOptions}
          onRowDoubleClicked={onRowDoubleClicked}
        // onFirstDataRendered={onFirstDataRendered}
        ></AgGridReact>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </div>
      <SpeedDialComponent showColumn={showColumn} hideColumn={hideColumn} />
    </div>
  );
}

export default ActPatientGrid;
